<script>
import Icon from '@/javascript/views/components/Icon.vue';
import { ColorPicker } from 'vue3-colorpicker';
import 'vue3-colorpicker/style.css';

export default {
  name: 'CircleColorPicker',
  components: { Icon, ColorPicker },
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    colorLabel: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      // mirror the v-model value
      internalColor: this.modelValue || ''
    };
  },
  watch: {
    // when parent changes, update local
    modelValue(val) {
      this.internalColor = val || '';
    },
    // when local changes, emit to parent
    internalColor(val) {
      this.$emit('update:modelValue', val);
    }
  },
  methods: {
    clearColor() {
      this.internalColor = '';
      this.$emit('update:modelValue', '');
    }
  }
};
</script>

<template>
  <div class="circle-picker-wrapper">
    <div class="picker-container">
      <!-- actual picker -->
      <ColorPicker
        v-model:pure-color="internalColor"
        format="hex"
        shape="circle"
        disable-alpha
        :disabled="disabled"
        class="circle-trigger"
      />

      <!-- empty state circle + plus -->
      <div
        v-if="!internalColor"
        class="empty-circle"
      >
        <Icon
          icon="plus"
          size="12px"
        />
      </div>

      <!-- clear “×” -->
      <Icon
        v-if="internalColor"
        icon="x"
        size="10px"
        class="clear-button"
        @click.stop="clearColor"
      />
    </div>

    <!-- label -->
    <div
      v-if="colorLabel"
      class="circle-color-label"
    >
      {{ colorLabel }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.circle-picker-wrapper {
  display: inline-flex;
  flex-direction: column;
  align-items: center;

  .picker-container {
    position: relative;
    width: 30px;
    height: 30px;

    // make both picker & empty placeholder fill the container
    .circle-trigger,
    .empty-circle {
      width: 100%;
      height: 100%;
    }

    // override vue3-colorpicker’s wrapper
    :deep(.vc-color-wrap.round) {
      width: 30px !important;
      height: 30px !important;
      border-radius: 50% !important;
      border: 1px solid #d8d8d8 !important;
    }

    .empty-circle {
      position: absolute;
      top: 0;
      left: 0;
      border: 1px solid #ccc;
      border-radius: 50%;
      background: white;
      display: flex;
      align-items: center;
      justify-content: center;
      pointer-events: none;
    }

    .circle-trigger {
      border: none;
      background: transparent;
      padding: 0;
      cursor: pointer;

      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
      }
    }

    .clear-button {
      position: absolute;
      top: 0;
      right: 0;
      width: 16px;
      height: 16px;
      background: white;
      border: 1px solid lightgrey;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      box-sizing: border-box;
      transform: translate(25%, -25%);
    }
  }

  .circle-color-label {
    margin-top: 4px;
    font-size: 10px;
    color: #6b7280;
    text-align: center;
    line-height: 1;
  }
}
</style>

